import { Text } from '@capsicum/common-web';
import { useNCWSendAssetNoSearchResults } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

/**
 * A message for the "no data found" scenario of the search functionality
 */
export const NCWSendAssetNoSearchResults = () => {
	const { intlText } = useNCWSendAssetNoSearchResults();

	return (
		<S.Wrapper>
			<Text variant="title6">{intlText.noSearchResultTitle}</Text>
			<Text variant="text5">{intlText.noSearchResultDescription}</Text>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		text-align: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		padding-block: ${({ theme }) => theme.spacings.small};
	`;
}
